import { get } from "../../utils/object-helpers";

<if(input)>
    $ {
        const vacationMessage = get(input, 'message', {});
        const hasVacationMessage = Object.keys(vacationMessage).length == 0 ? false : true;
        const profileEditState = get(input, 'globalState.profileEdit', {});
        const profileEditError = get(profileEditState, 'saveError.modules.STATUS_MESSAGE_INLINE_MODULE', null);
        const isEditing = get(profileEditState, 'editing', false);
    }
    <if(hasVacationMessage)>
        <str-status message=vacationMessage class="app-layout" />
    </if>
    <if(profileEditError && isEditing)>
        <str-status ...profileEditError class="app-layout" />
    </if>
    <div class="str-header-wrap" key="str-header-wrap">
        <div class="str-header app-layout" data-testid="header">
            <str-header-manage ...input />
            <str-header-banner ...input />
        </div>

        <!--====================
        // Sentinel needed for the sticky mini header (str-mini-header)
        ========================-->
        <div class="str-header__sticky-sentinel"></div>
        <div class="str-left-nav__sticky-sentinel"></div>
    </div>
</if>
